import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
const SVGComponent = (props: any) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.2} fill={props?.bgColor ?? "#F3F5FC"} />
    <Path
      opacity={0.2}
      d="M13.6172 28.3828H10.6641C10.4683 28.3828 10.2805 28.305 10.142 28.1666C10.0036 28.0281 9.92578 27.8403 9.92578 27.6445V23.9531C9.92578 23.7573 10.0036 23.5695 10.142 23.4311C10.2805 23.2926 10.4683 23.2148 10.6641 23.2148H13.6172V28.3828Z"
      fill={props?.color ?? "#1434CB"}
    />
    <Path
      d="M13.6172 28.3828H10.6641C10.4683 28.3828 10.2805 28.305 10.142 28.1666C10.0036 28.0281 9.92578 27.8403 9.92578 27.6445V23.9531C9.92578 23.7573 10.0036 23.5695 10.142 23.4311C10.2805 23.2926 10.4683 23.2148 10.6641 23.2148H13.6172"
      stroke={props?.color ?? "#1434CB"}
      strokeWidth={1.18125}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M19.5234 23.9531H22.4766L28.6597 22.531C28.887 22.4687 29.1256 22.4597 29.357 22.5046C29.5884 22.5495 29.8063 22.6472 29.9938 22.7901C30.1813 22.9329 30.3333 23.1171 30.438 23.3282C30.5428 23.5394 30.5974 23.7719 30.5977 24.0076C30.5978 24.2922 30.5186 24.5712 30.3689 24.8132C30.2193 25.0553 30.0051 25.2509 29.7505 25.378L26.168 26.9063L20.2617 28.3828H13.6172V23.2148L15.9243 20.9077C16.1305 20.7022 16.3752 20.5394 16.6444 20.4285C16.9136 20.3177 17.202 20.261 17.4932 20.2617H22.1074C22.5969 20.2617 23.0664 20.4562 23.4125 20.8023C23.7587 21.1485 23.9531 21.6179 23.9531 22.1074C23.9531 22.5969 23.7587 23.0664 23.4125 23.4125C23.0664 23.7587 22.5969 23.9531 22.1074 23.9531H19.5234Z"
      stroke={props?.color ?? "#1434CB"}
      strokeWidth={1.18125}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M26.9062 11.4023V18.7852"
      stroke={props?.color ?? "#1434CB"}
      strokeWidth={1.18125}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M29.8594 15.832L26.9062 18.7852L23.9531 15.832"
      stroke={props?.color ?? "#1434CB"}
      strokeWidth={1.18125}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
export default SVGComponent;
